import React from "react"
import { makeStyles } from "@material-ui/styles"
import Typography from "@material-ui/core/Typography"
import { FormattedMessage } from "react-intl"
import { Button } from ".."
import { navigate } from "gatsby-link"

const useStyles = makeStyles(theme => ({
  emptyCart: {
    textAlign: "center",
    position: "absolute",
    top: "40%",
    width: "100%",
  },
  emptyText: {
    color: theme.palette.green.main,
  },
  emptyButton: {
    marginTop: theme.spacing(5),
  },
}))

const EmptyCart = props => {
  const classes = useStyles()

  return (
    <div className={classes.emptyCart}>
      <Typography
        variant={"h4"}
        component={"div"}
        classes={{ root: classes.emptyText }}
      >

        <FormattedMessage id="noItemsInCart" />
        <br />
        <FormattedMessage id="startBrowsing" />

      </Typography>
      {/* @TODO add link to all products page */}
      <Button className={classes.emptyButton} color={"green"} onClick={event => {
        event.preventDefault()
        navigate(props.redirectTo)
      }}>
        <FormattedMessage id="ViewAllProducts" />
      </Button>
    </div>
  )
}

export default EmptyCart
